import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import usePaginator from "../../../../theme/Component/usePaginator";
import { Singleton } from "../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { _ClinicalDocumentEvent, _DiagnosisHelp, _HealthScope, _HealthServiceProvision, _MeansAdministration, _PharmaCumState, _PharmaRecordState } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { HealthLOINCEditor } from "../../../../GestionTerceros/AbstractAccount/HealthLOINC/HealthLOINCEditor";
import { HealthAssesmentResultEditor } from "../../../../GestionTerceros/AbstractAccount/HealthAssesmentResult/HealthAssesmentResultEditor";
import { ClinicalDocumentState } from "./ClinicalDocumentState";

interface Props {
    idClinicalDocument: number;
    issueDate: any
}

export const ClinicalDocumentEvent = ({ idClinicalDocument, issueDate }: Props) => {

    const event = useDataBean(_ClinicalDocumentEvent);
    const paginador = usePaginator();
    const [form, setForm] = useState<any>({
        IDHealthLOINC: null,
        LOINC_NUM: null,
        IDHealthAssesmentResult: null,
        HealthAssesmentResultName: null
    })
    const [regexStr, setregexStr] = useState<any>(null)
    const [state, setstate] = useState<any>(null)
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalcreate, setModalcreate] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idClinicalDocument, issueDate, paginador.page])

    const getLista = () => {

        event.instance.getClinicalDocumentEventCatalog(idClinicalDocument, issueDate, state, regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    let x = resp.List;
                    x.forEach((user) => {
                        user.DataBeanProperties.Acc = (user.DataBeanProperties.EmployeeName1 ?? "")
                            + "-" + (user.DataBeanProperties.EmployeeName2 ?? "") + "-" + (user.DataBeanProperties.EmployeeSurname1 ?? "") + "-" + (user.DataBeanProperties.EmployeeSurname2 ?? "");
                    });
                    setLista(x)
                }
            }
        )

    }
    const create = () => {
        event.setBean({
            IDClinicalDocument: idClinicalDocument,
            IssueDate: issueDate
        });
        setModalcreate({ ...modalcreate, "view": true });
    }
    const deleteItem = () => {
        event.instance.deleteVoid(event.bean.IDHealthServiceProvision).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }

    const editaItem = () => {
        //console.log(entailment.bean);
        event.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDClinicalDocumentEvent', visible: true },
        { title: 'Fecha Evento', property: 'InitDate', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Id Empleado', property: 'EmployeeNit', visible: true },
        { title: 'Empleado', property: 'Acc', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    return (

        <div className="row">
            <div className="col-md-12">
                <label>Eventos</label>
            </div>
            <div className="col-md-4">
                <ClinicalDocumentState idSelector={state} onChange={(e) => { setstate(e) }} />
            </div>
            <div className="col-md-4">
                <label>Búsqueda por Texto</label>
                <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
            </div>
            <div className="col-md-4 mt-4 p-2">
                <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
            </div>
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={event.setBean} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>

                <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                    <div className="row">

                    </div>
                </Modal>
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item {event.bean.Name}</strong>
                </ModalConfirm>
            </div>

        </div>

    )
}